<template lang="pug">
.v-ads.advrtsmnt(v-if="data" :class="{'open': isActionsOpen}")
	.advrtsmnt__inner
		.advrtsmnt__top
			a.advrtsmnt__top-link(v-if="data?.link?.href"
				:href="data?.link?.href"
				)
			.advrtsmnt__top-wrap
				.advrtsmnt__header-info(v-if="data.header && data.header.info") {{data.header.info}}
				.advrtsmnt__top-main
					.advrtsmnt__top-visual
						img.advrtsmnt__top-visual-img(v-if="data.img && data.img.src"
							:src="data.img.src"
							:alt="data.img.alt"
						)
					.advrtsmnt__top-name
						.advrtsmnt__top-name-text(v-if="data.name") {{data.name}}
						.advrtsmnt__top-name-id(v-if="data.id") {{data.prefixId || 'ID'}}:{{data.id}}
						.advrtsmnt__top-price(v-if="data.price")
							template(v-if="data.price.current")
								span.advrtsmnt__top-price-current-currency(v-if="data.price.current.currency") {{data.price.current.currency}}&nbsp
								span.advrtsmnt__top-price-current-value(v-if="data.price.current.value") {{formatInteger(data.price.current.value)}}
			.advrtsmnt__top-wrap-info
				.advrtsmnt__header-detail(v-if="data.header && data.header.detail") {{data.header.detail}}
				.advrtsmnt__top-info
					.advrtsmnt__top-detail(v-if="data.detail" v-html="data.detail" )
			.advrtsmnt__top-wrap-info
				.advrtsmnt__header-time(v-if="data.header && data.header.time") {{data.header.time}}
				.advrtsmnt__top-info
					.advrtsmnt__top-renewal(v-if="data.renewal")
						span.advrtsmnt__top-renewal-time(v-if="data.renewal.time") {{ data.renewal.time }}
						span.advrtsmnt__top-renewal-date(v-if="data.renewal.date") ,&nbsp;{{ data.renewal.date }}
			.advrtsmnt__top-wrap-info
				.advrtsmnt__header-date(v-if="data.header && data.header.date") {{data.header.date}}
				.advrtsmnt__top-info
					.advrtsmnt__top-date(v-if="data.date")
						.advrtsmnt__top-date-wrap
							.advrtsmnt__top-date-text(v-if="data.date.text") {{data.date.text}}
				.advrtsmnt__top-status(v-if="data.status && data.status.text" :class="data.status?.className") {{ data.status.text }}
				.advrtsmnt__top-date(v-if="data.dateBottom")
					.advrtsmnt__top-date-wrap
						.advrtsmnt__top-date-text(v-if="data.dateBottom.text") {{data.dateBottom.text}}
				.advrtsmnt__top-status(v-if="data.statusBottom && data.statusBottom.text" :class="data.statusBottom?.className") {{ data.statusBottom.text }}
				.advrtsmnt__top-owner(v-if="data.owner" ) {{ data.owner }}
			.advrtsmnt__top-wrap-type
				.advrtsmnt__header-status(v-if="data.header && data.header.status") {{data.header.status}}
				.advrtsmnt__top-type
					.advrtsmnt__top-type-value(v-if="data.type && data.type.text" :style="{backgroundColor: data.type?.background || '#42948E', color: data.type?.color || '#FFF'}") {{data.type.text}}
			template(v-if="data.buttons" )
				button.advrtsmnt__top-button(v-for="(button, index) in data.buttons"
					:key="index"
					@click="isActionsOpen = !isActionsOpen")
					v-svg-icon.advrtsmnt__top-button-icon(v-if="button.icon"
						:icon="button.icon"
						:class="{'rotate-180' : isActionsOpen}")
			.advrtsmnt__top-cost(v-if="data.fullPrice")
				.advrtsmnt__top-cost-title(v-if="data.fullPrice.text" ) {{ data.fullPrice.text }}:
				template(v-if="data.fullPrice.current")
					span.advrtsmnt__top-cost-current-currency(v-if="data.fullPrice.current.currency") {{data.fullPrice.current.currency}}&nbsp
					span.advrtsmnt__top-cost-current-value(v-if="data.fullPrice.current.value != null") {{formatInteger(data.fullPrice.current.value)}}
			//.ads__top-month(v-if="data.term")
			//	.ads__top-label(v-if="isXs && data.term.label") {{data.term.label}}
			//	.ads__top-month-value(v-if="data.term.text") {{data.term.text}}
		transition(name="collapse")
			.advrtsmnt__bottom(v-if="isActionsOpen" )
				ul.advrtsmnt__links
					template(v-for="({action, text, href, icon}, ind) in data.actions" :key="ind" )
						li.advrtsmnt__links-item
							template(v-if="href")
								a.advrtsmnt__links-item-btn(v-if="text" :href="href")
									v-svg-icon.advrtsmnt__links-item-btn-icon(:icon="icon")
									| {{text}}
							template(v-else)
								button.advrtsmnt__links-item-btn(v-if="text" @click="handleClick(action)" :class="{'remove': action === 'remove'}")
									v-svg-icon.advrtsmnt__links-item-btn-icon(:icon="icon")
									| {{text}}

</template>


<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';
import formattingMixin from '../components/mixins/v-mixin-formatting.vue';

export default {
	emits: [
		'action',
	],
	mixins: [
		sourceMixin,
		isMobMixin,
		formattingMixin
	],
	data() {
		return {
			data: null,
			isActionsOpen: false
		}
	},
	methods: {

		dataSet(data) {
			this.data = data;
		},

		handleClick(action) {
			this.$emit('action', {action, id: this.data.id});
		}
	},

}
</script>